import firebase from 'firebase'
import 'firebase/firestore'
// import * as firebase from "firebase"

const firebaseConfig = {
    apiKey: "AIzaSyBN3kjPImTRLZ5sTWjnS6AbNhqnZPKyATA",
    authDomain: "ket2-600f4.firebaseapp.com",
    projectId: "ket2-600f4",
    storageBucket: "ket2-600f4.appspot.com",
    messagingSenderId: "37562700665",
    appId: "1:37562700665:web:1f6ae1782c9a0d3faf15a8"
}

export const firebaseApp = firebase.initializeApp(firebaseConfig)

firebaseApp.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebaseApp.auth().onAuthStateChanged(user => {
            unsubscribe()
            resolve(user)
        }, reject)
    })
}

export const auth = firebase.auth()

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

export const db = firebaseApp.firestore()

const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }
db.settings({ timestampsInSnapshots: true })
